import { useState } from "react";

import { SortState } from "@/types/resources";
import { SortDirection } from "@/utils/enums";

const useSortState = (
  defaultSortState: SortState = {
    direction: SortDirection.DEFAULT,
    property: "",
  }
) => {
  const [sort, setSort] = useState<SortState>(defaultSortState);

  const sortQueryParamObj = sort.direction !== "DEFAULT" && {
    sort: `${sort.direction === "DESC" ? "-" : ""}${sort.property}`,
  };

  return { sort, setSort, sortQueryParamObj };
};

export default useSortState;
